import { registerPlugin } from '@capacitor/core';
const CapgoCompass = registerPlugin('CapgoCompass', {
    web: () => import('./web').then((m) => new m.CapgoCompassWeb()),
});
export * from './definitions';
export { CapgoCompass };
//# sourceMappingURL=index.js.map